var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M16.59 13.79a1.4 1.4 0 0 1-1.98 0L10 9.18l-4.61 4.61a1.4 1.4 0 1 1-1.98-1.98l5.6-5.6a1.4 1.4 0 0 1 1.98 0l5.6 5.6a1.4 1.4 0 0 1 0 1.98",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUp;